export default "__VITE_ASSET__CWXx3KWY__"